import optimisticLogicData from '../logic/optimisticLogicData.js'

const resolveParam = (spec, params) =>
    typeof spec === 'string' && spec.startsWith('#') ? params[spec.slice(1)] : spec

const applySet = (set, params) =>
    Object.fromEntries(Object.entries(set).map(([k, v]) => [k, resolveParam(v, params)]))

const matchesLineId = (line, index, lineId) => {
    if (line.id != null) return line.id === lineId
    return lineId === `line-${index}`
}

// Match a line by a set of field conditions (values may be literals or #param
// references). Used by line.setWhere for group actions like "drop everything at
// this destination".
const matchesWhere = (line, match = {}, params) =>
    Object.entries(match).every(([field, spec]) => line[field] === resolveParam(spec, params))

const applyOptimistic = (entity, operation, doc, params) => {
    const entityConfig = optimisticLogicData[entity]
    const steps        = entityConfig?.[operation]
    if (!steps) return doc

    const linesField          = entityConfig.linesField          ?? 'lines'
    const totalLinesField     = entityConfig.totalLinesField     ?? 'totalLines'
    const completedLinesField = entityConfig.completedLinesField ?? 'completedLines'

    let lines = [...(doc[linesField] ?? [])]

    for (const step of steps) {
        if (step.type === 'line.set') {
            lines = lines.map((l, i) =>
                matchesLineId(l, i, params.lineId) ? { ...l, ...applySet(step.set, params) } : l
            )
        }

        if (step.type === 'line.setWhere') {
            lines = lines.map(l =>
                matchesWhere(l, step.match, params) ? { ...l, ...applySet(step.set, params) } : l
            )
        }

        if (step.type === 'line.insert') {
            const original = lines.find((l, i) => matchesLineId(l, i, params.lineId))
            if (original) {
                const newLine = {
                    ...original,
                    ...applySet(step.set, params),
                    id:        params.newLineId ?? crypto.randomUUID(),
                    sortOrder: (original.sortOrder ?? 0) + 0.5,
                }
                const idx = lines.findIndex(l => l.id === params.lineId)
                lines = [...lines.slice(0, idx + 1), newLine, ...lines.slice(idx + 1)]
            }
        }
    }

    return {
        ...doc,
        [linesField]:          lines,
        [totalLinesField]:     lines.length,
        [completedLinesField]: lines.filter(l => l.done).length,
    }
}

export default applyOptimistic
